import { render, staticRenderFns } from "./welcome-modal.vue?vue&type=template&id=3e655e0e&scoped=true&"
import script from "./welcome-modal.vue?vue&type=script&lang=js&"
export * from "./welcome-modal.vue?vue&type=script&lang=js&"
import style0 from "@/assets/sass/pages/home/welcome-modal.scss?vue&type=style&index=0&id=3e655e0e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e655e0e",
  null
  
)

export default component.exports